module.exports = __webpack_public_path__ + "img/荣誉证书.003b7426.svg";